<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <b-tabs content-class="mt-3">
          <b-tab title="Repair" active>
            <div class="border p-2">
              <div class="row">
                <div class="col-auto">
                  <span class="bg-primary text-white px-3 font-size-26">
                    {{ job.job_number }}</span
                  >
                </div>
                <div class="col">
                  <p class="text-muted mt-2 mb-0" v-if="job.manufacture">
                    {{ job.manufacture.description }} -
                    {{ job.device_type.description }}
                    <span v-if="job.device_model">
                      <br />
                      <strong>{{ job.device_model.code }}</strong> -
                      {{ job.imei_in ? job.imei_in : job.serial_in }}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col-12">
                <div v-if="job.assessed_by" class="border border-info p-3">
                  <small class="text-info my-2 font-weight-bold"
                    >ASSESSED BY</small
                  ><br />
                  <i class="lni lni-user"></i> {{ job.assessed_by.name }}<br />
                  <small class="text-muted">
                    {{
                      moment(new Date(job.assessed_date)).format(
                        "DD MMM YY, HH:mm"
                      )
                    }}
                  </small>
                </div>
              </div>
            </div>

            <h4 class="mt-3">Replacement Device:</h4>
            <p v-if="job.job_parts" class="text-primary font-weight-bold">
              {{ job.job_parts[0].part.description }}
            </p>

            <form-base
              class="maxWidth1000"
              :submit-status="submitStatus"
              :errors="errors"
              :loading="loading"
              action="Create"
              v-on:handleSubmit="handleSubmit"
            >
              <template v-slot:fields>
                <form-group label="IMEI #">
                  <input
                    type="text"
                    class="form-control"
                    v-model="job.imei_out"
                  />
                  <small v-if="$v.job.imei_out.$error" class="text-danger">
                    Please enter IMEI or a SERIAL# (IMEI Should be 15
                    Characters)
                  </small>
                </form-group>

                <form-group label="Serial #">
                  <input
                    type="text"
                    class="form-control"
                    v-model="job.serial_out"
                  />
                  <small v-if="$v.job.serial_out.$error" class="text-danger">
                    Please enter IMEI or Serial #
                  </small>
                </form-group>
              </template>
            </form-base>
          </b-tab>

          <b-tab title="Client" v-if="job.client_id">
            <client :id="job.client_id" class="mt-3"></client>
          </b-tab>

          <b-tab v-if="job.partner_id" title="Partner">
            <partner :id="job.partner_id" class="mt-3"></partner>
          </b-tab>

          <b-tab title="Job">
            <job-minimal :id="id"></job-minimal>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import jobRepo from "@/api/repos/jobRepo";
import partner from "@/views/modules/partners/show";
import { requiredIf, maxLength, minLength } from "vuelidate/lib/validators";
import client from "@/views/modules/clients/show";
import jobMinimal from "@/views/modules/jobs/enquiryMinimal";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
    partner,
    client,
    jobMinimal,
  },

  props: ["id"],

  mounted() {
    this.getCreatedData(this.id);
  },

  validations: {
    job: {
      imei_out: {
        required: requiredIf(function (job) {
          return job.serial_out == null;
        }),
        minLength: minLength(15),
        maxLength: maxLength(15),
      },
      serial_out: {
        required: requiredIf(function (job) {
          return job.imei_out == null;
        }),
      },
    },
  },

  data() {
    return {
      job: {},
      isLoad: false,
      loading: false,
      errors: null,
      submitStatus: null,
      sort: { column: "code", label: "Code Asc", order: "asc" },
      sortOptions: [
        { column: "code", label: "Code Asc", order: "asc" },
        { column: "code", label: "Code Desc", order: "desc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      sdvpid: 1,
    };
  },

  methods: {
    async getCreatedData(id) {
      try {
        this.loading = true;
        let { data } = await jobRepo.deviceReplaceCreate(id);
        this.job = data.job;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await jobRepo.deviceReplaceStore({
            id: this.id,
            serial_out: this.job.serial_out,
            imei_out: this.job.imei_out,
          });
          this.$emit("deviceReplaceCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

